import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberBin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M25.9 3A2.9 2.9 0 0 0 23 5.9V9h18V5.9A2.9 2.9 0 0 0 38.1 3zM43 9V5.9A4.9 4.9 0 0 0 38.1 1H25.9A4.9 4.9 0 0 0 21 5.9V9H6a1 1 0 0 0 0 2h4.56l2.84 46.142A6 6 0 0 0 19.28 63h25.44a6 6 0 0 0 5.88-5.858L53.44 11H58a1 1 0 1 0 0-2H43m-30.437 2 2.835 46.039.002.041A4 4 0 0 0 19.31 61h25.38a4 4 0 0 0 3.912-3.962L51.437 11z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M21.945 17.002a1 1 0 0 1 1.053.943l2 36a1 1 0 0 1-1.997.11l-2-36a1 1 0 0 1 .944-1.053m20.11 0A1 1 0 0 1 43 18.055l-2 36a1 1 0 0 1-1.998-.11l2-36a1 1 0 0 1 1.055-.943M32 17a1 1 0 0 1 1 1v36a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1",
		clipRule: "evenodd"
	})]
});
export default SvgCyberBin;
